<template>
    <div id="weatherGraph" style="background-color: #22293d;"></div>
</template>

<script>
import Highcharts from 'highcharts';
import load from 'highcharts/modules/vector';

export default {
    name: "weather-forecast",
    data: () => ({
        chart: null,
        textColor: "#fff",
        bgColor: "#22293d",
        isDarkMode: true,
        weatherData: null
    }),
    watch: {
        '$route.query.style': function() {
            var globv = this;
            globv.checkStyle();
        },
    },
    mounted() {
       var globv = this;
       globv.checkStyle();
    },
    methods: {
        checkStyle: function() {
            var globv = this;
            if (globv.$route.query.style && globv.$route.query.style == "light") {
                globv.textColor = "#22293d";
                globv.bgColor = "#F5F9FA";
                globv.isDarkMode = false;
            }
            else {
                globv.textColor = "#fff";
                globv.bgColor = "#22293d";
                globv.isDarkMode = true;
            }
            
            if (globv.weatherData && !globv.isDarkMode) {
                globv.createChart(globv.weatherData);
            }
        },
        createChart: function(weatherData) {
            var globv = this;

            if (weatherData) {
                globv.weatherData = weatherData;
                let series = [];

                let title = "Weather Forecast";
                if (globv.$route.params.mmsi) {
                    title += " for Current Location of " + (weatherData['name'] ? weatherData['name'] : globv.$route.params.mmsi);
                }
                else if (globv.$route.query.location) {
                    title += " for " + globv.$route.query.location;
                }
                else {
                    title += " at Lat " + globv.$route.query.lat + " and Lon " + globv.$route.query.lon;
                }

                let formatData = [
                    {
                        varName: "waveHeight",
                        labelName: "Wave Height",
                        chartOpt: {
                            type: 'column',
                            yAxis: 1,
                            tooltip: {
                                valueSuffix: " m",
                                valueDecimals: 3
                            },
                            color: "#2362BA",
                        },
                    },
                    {
                        varName: "airTemp",
                        labelName: "Air Temp",
                        chartOpt: {
                            type: 'spline',
                            tooltip: {
                                valueSuffix: "°C",
                                valueDecimals: 3
                            },
                            color: "#ED4553",
                            visible: false
                        },
                    },
                    {
                        varName: "seaTemp",
                        labelName: "Sea Temp",
                        chartOpt: {
                            type: 'spline',
                            tooltip: {
                                valueSuffix: "°C",
                                valueDecimals: 3
                            },
                            color: globv.isDarkMode ? "#6DDF76" : "#52C45C",
                            visible: false
                        },
                    },
                    {
                        varName: "dewTemp",
                        labelName: "Dew Temp",
                        chartOpt: {
                            type: 'spline',
                            tooltip: {
                                valueSuffix: "°C",
                                valueDecimals: 3
                            },
                            color: globv.isDarkMode ? "#86e1e4" : "#45C2DE",
                            visible: false
                        },
                    },
                    {
                        varName: "baromPressure",
                        labelName: "Barometric Pressure",
                        chartOpt: {
                            type: 'spline',
                            marker: {
                                enabled: false
                            },
                            dashStyle: 'shortdot',
                            yAxis: 2,
                            tooltip: {
                                valueSuffix: " kPa",
                                valueDecimals: 3
                            },
                            color: globv.isDarkMode ? "#F79C6A" : "#E87233",
                            visible: false
                        },
                    },
                    {
                        varName: "windSpeed",
                        labelName: "Wind Velocity",
                        chartOpt: {
                            type: 'spline',
                            yAxis: 3,
                            tooltip: {
                                pointFormatter: function() {
                                    return "";
                                }
                            },
                            marker: {
                                enabled: false
                            },
                            legend: {
                                enabled: false
                            },
                            color: "#D64287"
                        },
                    },
                    {
                        varName: "windSpeed",
                        varDir: "windDir",
                        labelName: "Wind Velocity",
                        chartOpt: {
                            type: 'vector',
                            yAxis: 3,
                            tooltip: {
                                pointFormatter: function() {
                                    let output = Highcharts.dateFormat('%A, %b %d, %H:%M', this.x) + '<br/>';
                                    output += "Speed: <b>" + (this.y * 1.943).toFixed(3) + " knts</b><br/>";
                                    output += "Direction: <b>" + (this.direction - 180).toFixed(3) + "°</b>";
                                    return output;
                                }
                            },
                            linkedTo: ':previous',
                            color: "#D64287"
                        },
                    },
                    {
                        varName: "currentSpeed",
                        labelName: "Ocean Current Velocity",
                        chartOpt: {
                            type: 'spline',
                            yAxis: 4,
                            tooltip: {
                                pointFormatter: function() {
                                    return "";
                                }
                            },
                            marker: {
                                enabled: false
                            },
                            color: globv.isDarkMode ? "#FFE033" : "#DEAD1B"
                        },
                    },
                    {
                        varName: "currentSpeed",
                        varDir: "currentDir",
                        labelName: "Ocean Current Velocity",
                        chartOpt: {
                            type: 'vector',
                            yAxis: 4,
                            tooltip: {
                                pointFormatter: function() {
                                    let output = Highcharts.dateFormat('%A, %b %d, %H:%M', this.x) + '<br/>';
                                    output += "Speed: <b>" + (this.y * 1.943).toFixed(3) + " knts</b><br/>";
                                    output += "Direction: <b>" + (this.direction - 180).toFixed(3) + "°</b>";
                                    return output;
                                }
                            },
                            linkedTo: ':previous',
                            color: globv.isDarkMode ? "#FFE033" : "#DEAD1B"
                        },
                    }
                ]

                let yAxisColorI = ["", "", "", "", ""];

                for (let format in formatData) {
                    let entirelyNulls = true;
                    let tempData = [];
                    let dataValues = weatherData[formatData[format]['varName']];
                    for (let d in dataValues) {
                        if (dataValues[d]['value'] != null && dataValues[d]['value'] != undefined) {
                            entirelyNulls = false;
                        }

                        let point = [dataValues[d]['validTime'], dataValues[d]['value']];
                        if (formatData[format]['varDir']) {
                            point.push(1);
                            point.push(weatherData[formatData[format]['varDir']][d]['value'] + 180);
                        }

                        tempData.push(point);
                    }

                    if (!entirelyNulls) {       
                        if (formatData[format]['chartOpt']['yAxis'] && yAxisColorI[formatData[format]['chartOpt']['yAxis']] == "") {
                            yAxisColorI[formatData[format]['chartOpt']['yAxis']] = formatData[format]['chartOpt']['color'];
                        }
                        else if (!formatData[format]['chartOpt']['yAxis']) {
                            yAxisColorI[0] = globv.textColor;
                        }

                        series.push({
                            name: formatData[format]['labelName'],
                            data: tempData,
                            ...formatData[format]['chartOpt']
                        });
                    }
                }

                load(Highcharts);

                if (series.length > 0) {
                     globv.chart = Highcharts.chart('weatherGraph', {
                        chart: {
                            backgroundColor: globv.bgColor
                        },
                        credits: {
                            enabled: false,
                            credits: false
                        },
                        title: {
                            text: title,
                            style: {
                                color: globv.textColor
                            }
                        },
                        subtitle: {
                            text: 'Source: spire.com',
                        },
                        tooltip: {
                            shared: true
                        },
                        legend: {
                            enabled: true,
                            itemStyle: {
                                color: globv.textColor
                            }
                        },
                        plotOptions: {
                            vector: {
                                vectorLength: 30
                            }
                        },
                        yAxis: [
                            {
                                title: {
                                    text: "Temperature",
                                    style: {
                                        color: globv.textColor
                                    }
                                },
                                gridLineWidth: 0,
                                labels: {
                                    enabled: true,
                                    style: {
                                        color: globv.textColor
                                    },
                                    format: "{value}°C"
                                },
                                visible: !(yAxisColorI[0] == ""),
                            },
                            {
                                title: {
                                    text: "Wave Height",
                                    style: {
                                        color: yAxisColorI[1]
                                    }
                                },
                                gridLineColor: "#666666",
                                labels: {
                                    style: {
                                        color: yAxisColorI[1]
                                    },
                                    format: "{value} m"
                                },
                                opposite: true,
                                visible: !(yAxisColorI[1] == ""),
                            },
                            {
                                title: {
                                    text: "Sea Level Pressure",
                                    style: {
                                        color: yAxisColorI[2]
                                    }
                                },
                                gridLineWidth: 0,
                                labels: {
                                    style: {
                                        color: yAxisColorI[2]
                                    },
                                    format: "{value} kPa"
                                },
                                opposite: true,
                                visible: !(yAxisColorI[2] == ""),
                            },
                            {
                                title: {
                                    text: "Wind Velocity",
                                    style: {
                                        color: yAxisColorI[3]
                                    }
                                },
                                gridLineWidth: 0,
                                labels: {
                                    style: {
                                        color: yAxisColorI[3]
                                    },
                                    format: "{value} knts"
                                },
                                opposite: true,
                                visible: !(yAxisColorI[3] == ""),
                            },
                            {
                                title: {
                                    text: "Current Velocity",
                                    style: {
                                        color: yAxisColorI[4]
                                    }
                                },
                                gridLineWidth: 0,
                                labels: {
                                    style: {
                                        color: yAxisColorI[4]
                                    },
                                    format: "{value} knts"
                                },
                                opposite: true,
                                visible: !(yAxisColorI[4] == ""),
                            }
                        ],
                        xAxis: {
                            type: 'datetime',
                            crosshair: true,
                            labels: {
                                style: {
                                    color: globv.textColor
                                }
                            }
                        },
                        series: series,
                        responsive: {
                            rules: [{
                                condition: {
                                    maxWidth: 900
                                },
                                chartOptions: {
                                    yAxis: [
                                        {
                                            labels: {
                                                enabled: false
                                            },
                                            title: {
                                                text: ""
                                            }
                                        },
                                        {
                                            visible: false
                                        },
                                        {
                                            visible: false
                                        },
                                        {
                                            visible: false
                                        },
                                        {
                                            visible: false
                                        }
                                    ]
                                }
                            }]
                        }
                    });
                }
            }
               
        },
        reflow: function() {
            var globv = this;
            if (globv.chart) {
                globv.chart.reflow();
            }
        },
    }
}
</script>